module.exports = __webpack_public_path__ + "img/162-669f13.png";